angular.module('picmonicng').directive('learnPicmonics', [
  'PicmonicQueue',
  'UserService',
  function (PicmonicQueue, UserService) {
    return {
      restrict: 'A',
      scope: {
        target: '=learnPicmonics',
        learnMethod: '@',
        learnStartWith: '=',
        learnPlaylist: '=',
        learnPlaylistPicmonics: '=',
        learnNewTab: '=',
      },
      controller: [
        '$modal',
        '$scope',
        'MarketOptionsConfig',
        '$cookies',
        'Tracks',
        '$state',
        '$filter',
        function ($modal, $scope, MarketOptionsConfig, $cookies) {
          $scope.showRegisterModal = function (card) {
            var lead = UserService.user.lead ? UserService.user.lead : $cookies.get('pls_user_lead');
            var market = MarketOptionsConfig.getMarketById(lead);

            $modal.open({
              templateUrl: '/templates/modals/register-modal.html',
              windowClass: 'registration-cta-modal full-screen-modal',
              backdropClass: 'modal-body-reduced',
              controller: 'RegisterModalController',
              resolve: {
                card: function () {
                  return card;
                },
                market_id: function () {
                  return lead;
                },
                copy: function () {
                  return null;
                },
                redirect: function () {
                  return null;
                },
                extraParams: function () {
                  return null;
                },
              },
            });
          };
        },
      ],
      link: function (scope, element, attrs) {
        element.bind('click', function (e) {
          var newTab = scope.learnNewTab;
          if (e.shiftKey || e.ctrlKey || e.metaKey) {
            newTab = true;
          }
          scope.$apply(function () {
            var autoplay = null;
            if (scope.learnMethod == 'play') {
              autoplay = true;
            }

            if (!UserService.user || !UserService.user.user_id) {
              scope.showRegisterModal(scope.target);
            } else {
              if (scope.learnMethod == 'quiz') {
                PicmonicQueue.setAndQuiz(scope.target, scope.learnStartWith);
              } else {
                if (scope.learnPlaylist) {
                  PicmonicQueue.setAndPlay(
                    scope.learnPlaylistPicmonics,
                    scope.target.card_id,
                    autoplay,
                    null,
                    scope.learnPlaylist.playlist_id,
                    newTab,
                    scope.learnPlaylist.studyplan_id
                  );
                } else {
                  PicmonicQueue.setAndPlay(scope.target, scope.learnStartWith, autoplay, null, null, newTab);
                }
              }
            }
          });
        });
      },
    };
  },
]);
